module.exports = __webpack_public_path__ + "static/media/banner-about.86a20ef1.jpg";